(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["physical-cart-feedback"] && !Shopify.designMode) return;
  try {
    if (!window.physicalCartEventsBound) {
    window.physicalCartEventsBound = true;
    document.addEventListener('click', event => {
      const dismiss = event.target.closest('[data-feedback-close]');
      if (dismiss) dismiss.closest('[data-add-feedback]').hidden = true;
    });
    document.addEventListener('submit', async event => {
      const form = event.target;
      if (!form.matches('form[data-physical-add]')) return;
      if (event.submitter && !event.submitter.matches('[data-submit], [data-quick-submit]')) return;
      event.preventDefault();
      if (form.dataset.pending === 'true') return;
      const feedback = form.querySelector('[data-add-feedback]');
      if (!feedback || !form.reportValidity()) return;
      const submit = form.querySelector('[data-submit], [data-quick-submit]');
      if (!submit || submit.disabled) return;
      const body = new FormData(form);
      const quickSelect = form.querySelector('[data-quick-variant]');
      if (quickSelect) body.set('quantity', quickSelect.options[quickSelect.selectedIndex].dataset.min || '1');
      const buttonContent = Array.from(submit.childNodes);
      const controls = Array.from(form.querySelectorAll('input, select, button')).filter(el => !el.closest('[data-add-feedback]'));
      const disabledStates = controls.map(el => el.disabled);
      form.dataset.pending = 'true'; form.setAttribute('aria-busy', 'true');
      controls.forEach(el => el.disabled = true);
      submit.textContent = feedback.dataset.loading;
      document.querySelectorAll('[data-add-feedback]').forEach(el => el.hidden = true);
      const root = window.Shopify?.routes?.root || '/';
      let added = false;
      let rejection = '';
      try {
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', body, headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(15000) });
        const result = await response.json();
        if (!response.ok) { rejection = typeof result.description === 'string' ? result.description : feedback.dataset.error; throw new Error(rejection); }
        added = true;
        feedback.querySelector('[data-add-status]').textContent = feedback.dataset.success;
        feedback.hidden = false;
        const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store', signal: AbortSignal.timeout(5000) });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('.site-header__cart').forEach(link => {
            const count = link.querySelector('[aria-hidden="true"]');
            if (count) count.textContent = String(cart.item_count);
            link.setAttribute('aria-label', `${link.querySelector('span')?.textContent || 'Cart'}, ${cart.item_count}`);
          });
        }
      } catch (error) {
        if (!added) {
          feedback.querySelector('[data-add-status]').textContent = rejection || feedback.dataset.error;
          feedback.hidden = false;
        }
      } finally {
        controls.forEach((el, index) => el.disabled = disabledStates[index]);
        submit.replaceChildren(...buttonContent);
        delete form.dataset.pending; form.removeAttribute('aria-busy');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reading-proof"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('reading-proof')) {
    customElements.define('reading-proof', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('.reading-proof__track');
        this.toggle = this.querySelector('[data-toggle]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.items = Array.from(this.track.children);
        this.items.forEach(item => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('data-clone', '');
          this.track.append(clone);
        });
        this.querySelector('.reading-proof__controls').hidden = false;
        this.setAttribute('data-ready', '');
        this.updateToggle();
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-toggle')) {
            this.paused = !this.paused;
            this.updateToggle();
          } else if (button.dataset.step) {
            this.paused = true;
            this.updateToggle();
            this.advance(Number(button.dataset.step));
          }
        }, { signal });
        this.track.addEventListener('pointerdown', () => { this.paused = true; this.updateToggle(); }, { signal });
        this.motion.addEventListener('change', () => { this.paused = this.motion.matches; this.updateToggle(); }, { signal });
        this.position = this.track.scrollLeft;
        this.track.addEventListener('scroll', () => { if (this.paused) this.position = this.track.scrollLeft; }, { signal });
        this.lastFrame = null;
        const tick = time => {
          const elapsed = this.lastFrame === null ? 0 : Math.min(time - this.lastFrame, 64);
          this.lastFrame = time;
          if (!this.paused && !document.hidden && !this.track.matches(':hover') && document.activeElement !== this.track) {
            const cycle = this.track.children[this.items.length].offsetLeft - this.items[0].offsetLeft;
            if (cycle > 0) {
              this.position = (this.position + elapsed * .028) % cycle;
              this.track.scrollLeft = this.position;
            }
          }
          this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }
      updateToggle() {
        this.position = this.track.scrollLeft;
        this.toggle.textContent = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.toggle.setAttribute('aria-pressed', String(this.paused));
      }
      advance(step) {
        const start = this.items[0].offsetLeft;
        const offsets = this.items.map(item => item.offsetLeft - start);
        const cycle = this.track.children[this.items.length].offsetLeft - start;
        const position = cycle > 0 ? this.track.scrollLeft % cycle : 0;
        const next = step > 0
          ? offsets.find(offset => offset > position + 2) ?? 0
          : offsets.findLast(offset => offset < position - 2) ?? offsets[offsets.length - 1];
        this.track.scrollTo({ left: next, behavior: this.motion.matches ? 'auto' : 'smooth' });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.abort?.abort();
        this.querySelectorAll('[data-clone]').forEach(item => item.remove());
        this.abort = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
